module.exports = __webpack_public_path__ + "static/logo-appero-49b9bcd207bb43c26b406874d6cd47b9.png";